import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import MaskedReveal from "@/components/MaskedReveal";
import FadeUp from "@/components/FadeUp";
import Breadcrumbs from "@/components/Breadcrumbs";
import { HUBS, conditionsForHub } from "@/data/care";

export default function Care() {
  return (
    <div data-testid="care-index-page" className="pt-28 md:pt-36 pb-28">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <FadeUp>
          <Breadcrumbs trail={[{ to: "/", label: "Home" }, { label: "Care" }]} />
          <div className="mt-8 kbd">— What we treat</div>
          <h1 className="mt-4 font-serif text-6xl md:text-[8vw] leading-[0.96] tracking-tightest max-w-5xl">
            <MaskedReveal text={"Seven hubs."} />
            <MaskedReveal text={"One doctor."} delay={0.1} className="italic font-normal" />
            <MaskedReveal text={"Thirty-four conditions."} delay={0.2} />
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-ink-muted leading-relaxed">
            Every hub below is one area of vascular and endovascular interventional radiology that Dr Sidhu personally practises. Under each hub you'll find the specific conditions, what treatment looks like, and when it's the right choice.
          </p>
        </FadeUp>

        <div className="mt-24 md:mt-32 space-y-6 md:space-y-8">
          {HUBS.map((h, i) => {
            const conditions = conditionsForHub(h.slug);
            return (
              <FadeUp key={h.slug} delay={i * 0.04}>
                <Link
                  to={`/care/${h.slug}`}
                  data-testid={`hub-card-${h.slug}`}
                  className="group block hairline p-6 md:p-10 bg-white/60 hover:bg-white transition-colors"
                >
                  <div className="grid grid-cols-12 gap-6 items-start">
                    <div className="col-span-12 md:col-span-2 kbd">
                      {h.kicker}
                    </div>
                    <div className="col-span-12 md:col-span-7">
                      <h2 className="font-serif text-3xl md:text-5xl tracking-tightest leading-[1.05] group-hover:text-crimson transition-colors">
                        {h.name}
                      </h2>
                      <p className="mt-4 text-ink-muted leading-relaxed max-w-xl">{h.lede}</p>
                      <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2 text-xs text-ink-muted">
                        {conditions.slice(0, 6).map((c) => (
                          <span key={c.slug} className="border-b border-ink/10">{c.name}</span>
                        ))}
                        {conditions.length > 6 && <span className="kbd">+{conditions.length - 6} more</span>}
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-3 md:text-right">
                      <div className="inline-flex items-center gap-2 text-sm text-ink group-hover:text-crimson transition-colors">
                        Explore hub <ArrowUpRight size={14} />
                      </div>
                      <div className="mt-2 kbd">{conditions.length} conditions</div>
                    </div>
                  </div>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </div>
  );
}
